module.exports = __webpack_public_path__ + "fa-brands-400.ed311c7a0ade9a75bb3e.woff2";


//////////////////
// WEBPACK FOOTER
// C:/ETT/Progetti/JumpvNext/Angular/AgentiWebUI/AgentiWebConqordOil.Web.UI/src/assets/fonts/fontawesome/fa-brands-400.woff2
// module id = ../../../../../src/assets/fonts/fontawesome/fa-brands-400.woff2
// module chunks = main